export const images = {
  stage: "https://static.prod-images.emergentagent.com/jobs/fb53c968-6afa-4246-ab56-f17048a4fefc/images/a7d9359ec711a14262af411b595bc865dc4b10b67a3ec6486909b6892cc7effa.jpeg",
  seated: "https://static.prod-images.emergentagent.com/jobs/fb53c968-6afa-4246-ab56-f17048a4fefc/images/3ae738c7c959e3245d206a90ef9ac9cbad655ddff8c41929adb7d8a0e06596ab.jpeg",
  simulator: "https://static.prod-images.emergentagent.com/jobs/fb53c968-6afa-4246-ab56-f17048a4fefc/images/1bb9d526fca6a3c2af0211c956e08c12bb8269f4a1ce0231a8b2ef959cea94d8.jpeg",
  community: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mazalan-pro/artifacts/mtit9gf5_Petanizer.webp",
};

export const craftPillars = [
  {
    code: "02.A",
    title: "Cloud & integration architecture",
    body: "Designing resilient paths between data, applications, teams, and the cloud platforms that keep them moving.",
    tags: ["Multicloud", "APIs", "Data", "Resilience"],
  },
  {
    code: "02.B",
    title: "Generative AI & agent workflows",
    body: "Turning emerging AI capabilities into useful, governed experiences that solve real customer and business problems.",
    tags: ["RAG", "Agents", "Evaluation", "Guardrails"],
  },
  {
    code: "02.C",
    title: "Full-stack product systems",
    body: "Building the connective tissue: web applications, dashboards, enterprise workflows, APIs, and deployment paths.",
    tags: ["React", "C#", "PHP", "SQL"],
  },
  {
    code: "02.D",
    title: "Technical storytelling",
    body: "Making difficult technology clear in discovery sessions, executive briefings, demos, workshops, and on stage.",
    tags: ["Keynotes", "Demos", "Strategy", "Mentoring"],
  },
];

export const careerPath = [
  {
    period: "2025—NOW",
    title: "Staff Solution Engineer",
    company: "Oracle Corporation Malaysia",
    body: "Leads architecture discovery, demonstrations, proofs of concept, executive briefings, and regional technical enablement across cloud, data, integration, and conversational AI.",
  },
  {
    period: "2022—2025",
    title: "Solution Engineer Specialist",
    company: "Oracle Corporation Malaysia",
    body: "Translated customer needs into tailored technical stories, reusable demos, and hands-on prototypes while partnering with sales, architects, and delivery teams.",
  },
  {
    period: "2020—2022",
    title: "Software Engineer",
    company: "YGL World Sdn Bhd",
    body: "Maintained applications, built editable dashboards, fixed complex defects, and deployed services across private infrastructure and public cloud environments.",
  },
  {
    period: "2019—2020",
    title: "Web Developer",
    company: "Tx Technologies Sdn Bhd",
    body: "Shipped audit, reporting, administration, mapping, and finance workflows across PHP and ASP.NET product suites.",
  },
  {
    period: "2018",
    title: "Systems Intern",
    company: "Vantage Point Consulting",
    body: "Built an expense-claim application and learned how enterprise systems turn process knowledge into working software.",
  },
  {
    period: "2015—2016",
    title: "IT Support Executive",
    company: "Soyoung Malaysia",
    body: "Created an online storefront and payment flow while supporting digital media, inventory, sales, and day-to-day technology operations.",
  },
];

export const skillGroups = [
  {
    code: "A / AI + DATA",
    title: "Make intelligence useful",
    skills: ["Conversational AI", "Autonomous agents", "RAG pipelines", "Vector search", "Prompt design", "AI evaluation"],
  },
  {
    code: "B / CLOUD + INTEGRATION",
    title: "Connect the moving parts",
    skills: ["Cloud architecture", "API gateways", "Integration design", "Multicloud systems", "Zero-trust thinking", "Observability"],
  },
  {
    code: "C / SOFTWARE + WEB",
    title: "Ship the actual thing",
    skills: ["React", "JavaScript", "C#", "PHP", "Python", "SQL", "ASP.NET", "Dashboards"],
  },
  {
    code: "D / PEOPLE + DELIVERY",
    title: "Move the room forward",
    skills: ["Executive briefings", "Keynote delivery", "Discovery workshops", "Proofs of concept", "Mentorship", "Technical advocacy"],
  },
];

export const contact = {
  email: "armandmazalan87@gmail.com",
  linkedin: "https://www.linkedin.com/in/armandmazalan/",
};

export const personalGallery = [
  {
    id: "simulator",
    image: images.simulator,
    kicker: "OUTSIDE THE BRIEF / 01",
    title: "Precision under pressure",
    alt: "Armand driving a racing simulator surrounded by multiple screens",
    caption: "Focus is a form of play.",
    body: "A high-focus reset: tune the variables, read the signal, commit to the next move.",
    telemetry: [
      { label: "MODE", value: "Immersive simulation" },
      { label: "PRACTICE", value: "Attention under pressure" },
      { label: "PARALLEL", value: "Calm decisions in complex systems" },
    ],
  },
  {
    id: "community",
    image: images.community,
    kicker: "OUTSIDE THE BRIEF / 02",
    title: "Make room for the room",
    alt: "Armand taking part in a community presentation event",
    caption: "Ideas get stronger in conversation.",
    body: "The work is never only individual. Listening closely, making space, and sharing the microphone changes what becomes possible.",
    telemetry: [
      { label: "SETTING", value: "Community exchange" },
      { label: "PRACTICE", value: "Listen, test, explain" },
      { label: "PARALLEL", value: "Build with people, not around them" },
    ],
  },
];